/**
 * This component is created to replace the manual DOM manipulation for record/delete popups.
 * It centralizes the options logic into a reusable and state-driven component.
 */
import React from "react";
import Notification from "../../notification";
import localizationStrings from "../../../statics/localization";

const RecordOptionsPopup = ({
  recordStatus,
  onClose, 
  onRecordSeries,
  onRecordEpisode,
  onDeleteSeries,
  onDeleteEpisode,
}) => {
  const isAddMode = recordStatus === "-2";

  const handleNotConfirm = () => {
    if (isAddMode) {
      onRecordEpisode();
    } else {
      onDeleteEpisode();
    }
    onClose(); // I still call onClose to let the parent know it should close.
  };
  
  const handleConfirm = () => {
    if (isAddMode) {
      onRecordSeries();
    } else {
      onDeleteSeries();
    }
    onClose();
  };

  return (
    <Notification
      text={isAddMode ? localizationStrings.recordOption : localizationStrings.deleteRecordOption}
      confirmText={isAddMode ? localizationStrings.recordAllSerie : localizationStrings.deleteAllSerie}
      notConfirmText={isAddMode ? localizationStrings.recordThisEpisode : localizationStrings.deleteRecordEpisode}
      
      // The actions are now wrapped
      onClickConfirm={handleConfirm}
      onClickNotConfirm={handleNotConfirm}

      dontUsePortal={true}
      switchButtons={true} 
    />
  );
};

export default RecordOptionsPopup;